import { useEffect } from 'react'
import { FilterBar } from '../FilterBar'
import { Box, Flex } from '@workwhile/ui'
import { usePulseContext } from 'pages/PulsePage/context/PulseProvider'
import { EmptyState } from '../EmptyState'
import { RatingMetrics } from './RatingMetrics'
import { RatingsTimeseries } from './RatingsTimeseries'
import { TopCompliments } from './TopCompliments'
import { TopComplaints } from './TopComplaints'
import { RatingsByLocation } from './RatingsByLocation'
import { TopWorkers } from './TopWorkers'
import { track } from 'lib/amplitude'

export function PerformanceMain() {
  const {
    state: { filters },
  } = usePulseContext()

  useEffect(() => {
    track('impression, pulse_page_performance', {
      filters,
    })
  }, [])

  return (
    <Box>
      <FilterBar />
      {filters.companyIds.length > 0 ? (
        <Flex flexDirection="column" gap={5} pb={4}>
          <RatingMetrics />
          <TopWorkers />
          <Flex flexDirection={['column', 'row']} gap={5}>
            <TopCompliments />
            <TopComplaints />
          </Flex>
          <RatingsTimeseries />
          <RatingsByLocation />
        </Flex>
      ) : (
        <EmptyState />
      )}
    </Box>
  )
}
